//import { ApolloClient, InMemoryCache, gql } from "@apollo/client/core";
import { AuthProvider } from "react-admin";
import {
  CREDENTIALS_LOCAL_STORAGE_ITEM,
  USER_DATA_LOCAL_STORAGE_ITEM,
} from "../constants";
import { Credentials } from "../types";
import axios from "axios";
import jwt_decode from "jwt-decode";
import { apolloClient } from "../data-provider/graphqlDataProvider";

export const jwtAuthProvider: AuthProvider = {
  login: async (credentials: Credentials) => {
    let data = {
      ...credentials,
      service: `${process.env.REACT_APP_AUTH_SERVICE}`
    }
    const userData = await axios.post(
      `${process.env.REACT_APP_LEMONADE_SERVER}/api/login`,
      data
    );
    console.log('login: ', userData)
    if (userData && userData.data.err) {
      let message = userData.data.err.message;
      let detailsMessages = userData.data.err.details.messages
      if (message === "Unauthorized" && detailsMessages.some((dm: any) => dm === "User is not registered yet"))
        return Promise.reject("NotRegistered");
      else if (message === "Unauthorized" && detailsMessages.some((dm: any) => dm === "The passed username/password are incorrect"))
        return Promise.reject("Incorrect");
      return Promise.reject();
    }
    else if (userData && userData.data) {
      localStorage.setItem(
        CREDENTIALS_LOCAL_STORAGE_ITEM,
        createBearerAuthorizationHeader(userData.data.accessToken)
      );
      localStorage.setItem(
        USER_DATA_LOCAL_STORAGE_ITEM,
        JSON.stringify(userData.data)
      );
      console.log('login resolve')
      return Promise.resolve();
    }
    return Promise.reject();
  },
  logout: () => {
    // console.log("1");
    localStorage.removeItem(CREDENTIALS_LOCAL_STORAGE_ITEM);
    localStorage.removeItem(USER_DATA_LOCAL_STORAGE_ITEM);
    apolloClient.clearStore().then()
    return Promise.resolve();
  },
  checkError: ({ status }: any) => {
    // console.log("2");
    if (status === 401 || status === 403) {
      localStorage.removeItem(CREDENTIALS_LOCAL_STORAGE_ITEM);
      return Promise.reject();
    }
    return Promise.resolve();
  },
  checkAuth: () => {
    // console.log("3");
    return localStorage.getItem(CREDENTIALS_LOCAL_STORAGE_ITEM)
      ? Promise.resolve()
      : Promise.reject();
  },
  getPermissions: () => {
    const credentials: any = localStorage.getItem(
      CREDENTIALS_LOCAL_STORAGE_ITEM
    );
    let decodedAccessToken: any;
    if (credentials) {
      const [, accessToken] = credentials.split(" ");
      decodedAccessToken = jwt_decode(accessToken);
    }
    console.log("Roles: ", decodedAccessToken.roles);
    return localStorage.getItem(CREDENTIALS_LOCAL_STORAGE_ITEM)
      ? Promise.resolve(decodedAccessToken.roles)
      : Promise.reject();
  },
  getIdentity: () => {
    console.log('getIdentity');
    // console.log("4");
    // const str: any = localStorage.getItem(CREDENTIALS_LOCAL_STORAGE_ITEM);
    //const decoded: any = jwt_decode(str);
    // console.log(decoded);
    // const userData: LoginMutateResult = JSON.parse(str || "");

    return Promise.resolve({
      id: "undefined", // decoded.sub,
      fullName: undefined,
      avatar: undefined,
    });
  },
};

export function createBearerAuthorizationHeader(accessToken: string) {
  return `Bearer ${accessToken}`;
  //return `${accessToken}`;
}

export async function generateOtp(mobile: string) {
  try {
    const res = await axios.post(`${process.env.REACT_APP_LEMONADE_SERVER}/api/generate-otp`, {
      mobile: `0${mobile}`,
      service: process.env.REACT_APP_AUTH_SERVICE
    })

    if (res.data) {
      if (res.data.err) {
        throw res.data.err.details.messages[0] === "mobile must be a phone number" ? "شماره موبایل اشتباه وارد شده است" : "خطا در برقراری ارتباط";
      }
      return res.data;
    }
  } catch (error) {
    throw error;
  }
}

export function getRoles() {
  const str: any = localStorage.getItem('credentials')
  if (!str)
    return ''
  const decoded: any = jwt_decode(str);
  return decoded.roles
}

export function checkTimeAuth() {
  const str: any = localStorage.getItem('credentials');
  if (!str)
    return;
  const decoded: any = jwt_decode(str);
  const currentTime = Math.floor(Date.now() / 1000);
  if (decoded.exp && currentTime > decoded.exp) {
    jwtAuthProvider.logout(true); 
  }
}

